export default __webpack_public_path__ + "static/media/fastmotors.19a51c17.webp";